import React from 'react';
import { Switch, Route, useRouteMatch } from 'react-router-dom';
import { Box } from '@mui/material';
import PersonalInfoMaster from './components/PersonalInfoMaster';
import PersonalInfoDetails from './components/PersonalInfoDetails/PersonalInfoDetails'
import PaymentMethodsDetails from './components/PaymentMethodsDetails/PaymentMethodsDetails';
import { generateTestId } from 'app/functions';
import * as routes from 'constants/routes';

export const PersonalInfoSection = ({ testID }) => {
  const { path } = useRouteMatch();

  return (
    <>
      <Box sx={{ display: { xs: 'none', md: 'block' } }}>
        <PersonalInfoDetails testID={generateTestId(testID, 'desktop-details')} />
        <PaymentMethodsDetails testID={generateTestId(testID, 'desktop-payment')} />
      </Box>

      <Box sx={{ display: { xs: 'block', md: 'none' } }}>
        <Switch>
          <Route exact path={path}>
            <PersonalInfoMaster testID={generateTestId(testID, 'master')} />
          </Route>

          <Route path={`${path}${routes.user_info_routes.personal_info_edit}`}>
            <PersonalInfoDetails testID={generateTestId(testID, 'details')} isMobileView />
          </Route>

          <Route path={`${path}${routes.personal_zone_routes.payment_methods}`}>
            <PaymentMethodsDetails testID={generateTestId(testID, 'payment')} isMobileView />
          </Route>
        </Switch>
      </Box>
    </>
  );
};

export default PersonalInfoSection;